import { APIs } from 'src/models/apis';
import { useQuery } from 'react-query';
import { useAPIs } from 'src/hooks/useAPIs';
import { QueryKey } from 'src/models/query';
import { useUserQuery } from 'src/modules/user/hooks/useUserQuery';

export const fetchEventTicket = async (apis: APIs, eventId: string) => {
  const directus = await apis.directus();

  return directus.api.tickets.get(eventId);
};

export const useEventTicketQuery = (eventId: string) => {
  const apis = useAPIs();
  const { data: user } = useUserQuery();

  return useQuery(
    [...QueryKey.EventTicket, eventId],
    () => fetchEventTicket(apis, eventId),
    { enabled: !!user },
  );
};
